import { format, isValid } from 'date-fns';

const dateToString = (date: Date) => (date && isValid(date) ? format(date, 'yyyy-MM-dd') : null);

export default dateToString;
